import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import usePresentPage, { selectors } from 'client/hooks/usePresentPage'
import { useWebsiteSettings } from 'client/store'
import { localeNames } from 'common/constants/localeTypes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Toggle } from 'src/editor/shared/ui-lib/toggle/toggle'
import { getWebsiteLocales } from 'src/editor/store/website-settings/website-settings-selector'
import { WebsiteLanguageSwitcherIcon } from 'src/shared/entities/website-language-switcher/website-language-switcher-icon'
import { WebsiteLanguageSwitcherInterface } from 'src/shared/types/entities/website-language-switcher-interface'
import { WebsiteLanguageSwitcherSettingsProps } from './website-language-switcher-settings'

export const WebsiteLanguageSwitcherSettingsLanguages = ({
  entity,
}: WebsiteLanguageSwitcherSettingsProps) => {
  const { t } = useTranslation()
  const locale = usePresentPage(selectors.getPageLocale)
  const updateEntity = useUpdateEntity<WebsiteLanguageSwitcherInterface>()
  const currentLocale: string = locale === 'pt' ? 'br' : locale
  const websiteLocales = useWebsiteSettings(getWebsiteLocales)
  const languageList = websiteLocales.sort((a, b) => {
    if (a === currentLocale) return -1
    if (b === currentLocale) return 1
    return 0
  })

  const handleLanguageExclude = (language: string) => (isExcluded: boolean) => {
    if (isExcluded) {
      updateEntity({
        ...entity,
        excludedLanguages: entity.excludedLanguages.filter(
          excludedLanguage => excludedLanguage !== language,
        ),
      })
    } else {
      updateEntity({
        ...entity,
        excludedLanguages: [...entity.excludedLanguages, language],
      })
    }
  }
  return (
    <>
      {languageList.map(el => (
        <Toggle
          key={el}
          onChange={handleLanguageExclude(el)}
          checked={!entity.excludedLanguages.includes(el)}
          labelClassName="justify-between w-full pt-2 pb-2 mb-3"
          startElement={
            <div className="flex items-center gap-2">
              <WebsiteLanguageSwitcherIcon locale={el} />
              {t(localeNames[el])}
            </div>
          }
          disabled={el === currentLocale}
        />
      ))}
    </>
  )
}
